import React from "react";
import { Link } from "react-router-dom";

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link to="/" className="text-sm text-blue-500 hover:underline">
          ← Back to RushGro
        </Link>

        <h1 className="text-4xl font-bold mt-6 mb-2">
          Terms & Conditions
        </h1>

        <p className="text-muted-foreground mb-10">
          Last updated: 24 August 2026
        </p>

        <div className="space-y-8 text-sm leading-7">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using the RushGro website, platform, dashboard,
              applications, Power Backup as a Service offerings or related
              services, you agree to comply with these Terms & Conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">2. RushGro Services</h2>
            <p>
              RushGro provides technology-enabled power backup services,
              subscriptions, asset deployment, monitoring, maintenance,
              reporting and related services for businesses and commercial
              customers.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">3. User Accounts</h2>
            <p>
              Users are responsible for maintaining accurate account
              information and protecting their login credentials. Users must
              not share credentials with unauthorized persons or use the
              platform for unlawful purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              4. Subscriptions and Payments
            </h2>
            <p>
              Applicable subscription charges, taxes, billing cycles,
              payment terms, deposits and commercial conditions will be
              communicated through the relevant proposal, quotation,
              agreement, invoice or subscription plan.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              5. Installation and Assets
            </h2>
            <p>
              Equipment supplied under RushGro services may remain the
              property of RushGro or its financing, leasing or asset partners
              unless otherwise stated in a written agreement. Customers must
              not sell, transfer, damage, modify or relocate such assets
              without authorization.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              6. IoT Monitoring
            </h2>
            <p>
              Certain RushGro assets may use connected devices and third-party
              IoT systems for operational monitoring. Data availability may
              depend on connectivity, hardware availability and third-party
              systems and cannot be guaranteed at all times.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              7. Maintenance and Service
            </h2>
            <p>
              Maintenance obligations, response times, warranty coverage and
              exclusions may vary depending on the selected service plan,
              equipment and commercial agreement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              8. Acceptable Use
            </h2>
            <p>
              Users must not misuse the platform, attempt unauthorized access,
              interfere with platform functionality, reverse engineer systems,
              introduce malicious software or use RushGro services for
              illegal activities.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              9. Service Availability
            </h2>
            <p>
              RushGro will make reasonable efforts to maintain service
              availability. However, temporary interruption may occur due to
              maintenance, internet connectivity, power infrastructure,
              third-party services, technical failures or circumstances
              beyond reasonable control.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              10. Intellectual Property
            </h2>
            <p>
              The RushGro brand, website, platform, software, designs,
              documentation, dashboards and related intellectual property are
              protected by applicable laws and may not be copied or
              commercially exploited without authorization.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              11. Limitation of Liability
            </h2>
            <p>
              To the extent permitted by applicable law, RushGro will not be
              liable for indirect, incidental or consequential losses arising
              from use of the platform, third-party services, connectivity
              issues or circumstances outside RushGro's reasonable control.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              12. Termination
            </h2>
            <p>
              RushGro may suspend or terminate access where a user violates
              these terms, fails to make required payments, misuses equipment
              or services, or where termination is otherwise permitted by the
              applicable commercial agreement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              13. Governing Law
            </h2>
            <p>
              These Terms & Conditions will be governed by the laws of India.
              Any dispute will be subject to the jurisdiction specified in
              the applicable customer or commercial agreement, or otherwise
              the competent courts in India.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">14. Contact</h2>
            <p>
              RushGro<br />
              Email: support@rushgro.com<br />
              Website: rushgro.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}